module.exports = "https://cb-static.prod-my.games/promo/twitchdrops/img/mygames-market.fb594ad1.svg";